import { render, staticRenderFns } from "./ClientsAccessHeaders.vue?vue&type=template&id=6037b068&scoped=true"
import script from "./ClientsAccessHeaders.vue?vue&type=script&lang=js"
export * from "./ClientsAccessHeaders.vue?vue&type=script&lang=js"
import style0 from "./ClientsAccessHeaders.vue?vue&type=style&index=0&id=6037b068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6037b068",
  null
  
)

export default component.exports